import { render, staticRenderFns } from "./category-form.vue?vue&type=template&id=4e77c096&"
import script from "./category-form.vue?vue&type=script&lang=js&"
export * from "./category-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports